import React from "react";
import PropTypes from "prop-types";
import {
  Card,
  CardHeader,
  CardBody,
  CardFooter,
  Row,
  Col
} from "reactstrap";
import { NavLink } from "react-router-dom";
/** BLOQUES */
import BarraSelecionarRegion from "./barra-seleccionar-region.block";
import BarraSelecionarTematica from "./barra-seleccionar-tematica.block";
import BloqueDatosDeRegion from "./bloque-datos-de-region.block";
import BloqueGraficos from "./bloque-graficos.block";
import BloqueEstadistica from "./bloque-estadisticas";
import SeccionDocumentos from "./../vista-tematicas-ambientales/seccion-datos-documentos";
import IndicadoresAmbientales from "../../commons/indicadores.module";
import StringUtils from "../../commons/string-utils.module";
import Ubigeo from "../../commons/ubigeo.module";
import { DataService } from "../../services/data.service";
import MapLegend from "../vista-mapas/map-legend";
import LayersUtils from "../vista-tematicas-ambientales/LayersUtils";
import SVGIcon from "../../components/Utils/svgIcons";
import MapComponent from "../vista-tematicas-ambientales/MapComponent";
import MapZoom from '../../components/Utils/icon_map_minus.svg';
// Styles
import "./vista-regiones.view.scss";

const DEFAULT_REGION_CODE = "01";
const DEFAULT_TEMATICA_CODE = "04";
const DEFAULT_VIEW_MAP=false;
const DEFAULT_METADATA=false;
class VistaRegiones extends React.Component {
  static contextTypes = {
    router: PropTypes.object
  };
  constructor(props) {
    super(props);
    VistaRegiones.instanceCount++;
    let me = this;
    me.instanceId = VistaRegiones.instanceCount;
    // Guardar paramentros de la URL
    me.urlParams = StringUtils.getUrlParams(props.location.search);
    me.state = {
      region: me.getCodigoRegionInicial(),
      tematica: me.getCodigoTematicaInicial(),
      viewMap:me.getViewMap(),
      viewMetadata:me.getViewMetadata(),
      inlineCharts: 6,
      data_documento: [],
      data_norma: [],
      data_ubigeo: [],
      availableStore: false,
      showLayer: true,
      dataLayer: [],
      listLayer: [],
      dataLegend: [],
      showLegend: false,
      md_col_size: 12,
      showMenuLeft: true
    };
    this.handleClickLayerToogle = this.handleClickLayerToogle.bind(this);
    this.handleClickLayer = this.handleClickLayer.bind(this);
    this.handleClickLayerLegend = this.handleClickLayerLegend.bind(this);
    this.handleClickMenuLeft = this.handleClickMenuLeft.bind(this);
  }
  componentDidMount() {
    let me = this;
    me.processingData(me.state.region);
    me.loadLayerMap(me.state.tematica);
    IndicadoresAmbientales.formatRawData(function (indicadores) {
      me.setState({
        availableStore: true
      });
    });
  }
  getMapLegendId() {
    return "map-region-" + this.instanceId;
  }
  processingData(ubigeo) {
    let me = this;
    /**
     * Seccion Documentos y Normas
     */
    DataService.getData(
      {
        query: "SNA04",
        ubigeo: ubigeo,
        pnum: 0,
        psize: 3
      },
      function (result) {
        me.setState({
          data_documento: result.SNA04.data
        });
      }
    );
    DataService.getData(
      {
        query: "SNA05",
        ubigeo: ubigeo,
        pnum: 0,
        psize: 3
      },
      function (result) {
        me.setState({
          data_norma: result.SNA05.data
        });
      }
    );
    /**
     * Consulta de indicadores por ubigeo
     */
    DataService.getData(
      {
        query: "SNA03",
        ubigeo: ubigeo,
      },
      function (result) {
        me.setState({
          data_ubigeo: result.SNA03.data
        });
      }
    );
  }
  handleClickLayerLegend(e) {
    e.preventDefault();
    let isVisible = this.state.showLegend;
    isVisible = !isVisible;
    this.setState({
      showLegend: isVisible
    });
  }
  handleClickMenuLeft(e) {
    e.preventDefault();
    let isVisible = this.state.showMenuLeft;
    isVisible = !isVisible;
    this.setState({
      showLegend: !isVisible,
      showMenuLeft: isVisible,
      md_col_size: isVisible ? 12 : 12
    });
  }
  handleClickLayerToogle(e) {
    e.preventDefault();
    let isVisible = this.state.showLayer;
    isVisible = !isVisible;
    this.setState({
      showLayer: isVisible
    });
  }
  handleClickLayer(event) {
    let me = this;
    let dataLayer = [
      {
        url: event.target.attributes.getNamedItem("url").value,
        visible: event.target.attributes.getNamedItem("visible").value === "true",
        layerName: event.target.attributes.getNamedItem("layer").value,
        type: event.target.attributes.getNamedItem("layertype").value,
        link: event.target.attributes.getNamedItem("link").value,
        label: event.target.attributes.getNamedItem("label").value,
        fuente: event.target.attributes.getNamedItem("fuente").value,
        id: event.target.id,
        checked: event.target.checked,
        init: false
      }
    ];
    let new_store = [];
    let found = false;
    me.state.dataLegend.forEach(item => {
      if (item.id == event.target.id) {
        new_store.push(event);
        found = true;
      } else {
        new_store.push(item);
      }
    });
    if (!found) {
      new_store.push(dataLayer[0]);
    }
    this.setState({
      dataLayer: dataLayer,
      dataLegend: new_store
    });
  }
  loadLayerMap(marco) {
    let me = this;
    LayersUtils.getLayers(marco, function (data) {
      if (data.child) {
        me.setState({
          listLayer: data.child,
          dataLegend: []
        });
      } else {
        me.setState({
          listLayer: [],
          dataLegend: []
        });
      }
    });
  }
  render() {
    let me = this;
    const {
      tematica,
      region,
      inlineCharts,
      data_documento,
      data_norma,
      data_ubigeo,
      availableStore,
      showLayer,
      listLayer,
      showLegend,
      dataLegend,
      showMenuLeft,
      dataLayer,
      md_col_size,
      viewMap,
      viewMetadata
    } = me.state;
    let instanceLegendMap = me.getMapLegendId();
    return (
      <div className="vista-regiones">
      
      {viewMetadata ? (<Row>
              <Col >
                    <div className="text-primary">
                    <span><h5>Datos generales</h5></span>
                    </div>
              </Col>
        </Row> ) : 
                            (<p></p>)
                          }  
        {viewMetadata ? (<BloqueDatosDeRegion data={data_ubigeo} idRegion={region} /> ) : 
                            (<p></p>)
                          }  
         
        
        <Row>
            <Col xs={12} sm={7} md={9} xl={10}>
                    <div className="text-primary">
                    <span><h5>Estadística ambiental</h5></span>
                    </div>
                  </Col>
        </Row>
        <BarraSelecionarTematica
          tematica={tematica}
          onTematicaChange={me.onTematicaChange}
          scope={me}
        />
        <BloqueEstadistica 
           availableStore={availableStore}
            idRegion={region}
            idTematica={tematica} />
         {viewMap ? (<Row>
            <Col xs={12} sm={7} md={9} xl={10}>
                    <div className="text-primary">
                    <span><h5>Información geoespacial</h5></span>
                    </div>
                  </Col>
        </Row> ) : 
                            (<p></p>)
                          }  
        
        {viewMap ? (
                                  <Row>
                                  <Col xs={12} sm={12} md={12} xl={md_col_size}>
                                    <Card className="card-border-line mb-3">
                                      <CardBody>
                                        <div id="viewDiv" style={{ height: showMenuLeft ? "400px" : "700px" }}>
                                          <MapComponent dataLayer={dataLayer} legendName={instanceLegendMap} ubigeo={region} />
                                          <button
                                            className="button-overmap-calcite"
                                            onClick={me.handleClickLayerToogle}
                                            title="Ver Capas"
                                          ></button>
                                          <div
                                            className="map-component-layers"
                                            style={{ display: showLayer ? "block" : "none" }}
                                          >
                                            {listLayer.length > 0 ? (
                                              <ul>
                                                {listLayer.map(function (item, key) {
                                                  return (
                                                    <li key={item.id} title={"Fuente : " + item.fuente}>
                                                      <div className="layer_content">
                                                        <input
                                                          access={key}
                                                          key={item.id}
                                                          url={item.url}
                                                          id={item.id}
                                                          layer={item.layerName}
                                                          layertype={item.type}
                                                          visible={`${item.visible}`}
                                                          label={item.label}
                                                          link={item.link}
                                                          fuente={item.fuente}
                                                          defaultChecked={item.visible}
                                                          ref="complete"
                                                          type="checkbox"
                                                          onChange={me.handleClickLayer}
                                                        />
                                                        <span className="layer_content_text">
                                                          {item.label}
                                                        </span>
                                                      </div>
                                                    </li>
                                                  );
                                                })}
                                              </ul>
                                            ) : (
                                                <div>
                                                  <ul>
                                                    <li>
                                                      <div className="layer_content">
                                                        <i className="fas fa-info-circle col-size-icon text-primary"></i>
                                                        <span className="layer_content_text">
                                                          No existe capas para mostrar
                                                      </span>
                                                      </div>
                                                    </li>
                                                  </ul>
                                                </div>
                                              )}
                                          </div>
                                          <div className="control-panel shadow">
                                            <ul className="control-panel__list">
                                              <li
                                                className="control-panel__share-map pointer"
                                                title={showMenuLeft ?  "Ampliar Mapa" : "Reducir Mapa"}
                                                onClick={this.handleClickMenuLeft}
                                              >
                                                {showMenuLeft ? (
                                                  <SVGIcon id={"icon-map-zoom"} />
                                                ) : (
                                                    <SVGIcon id={"icon-map-minus"} />
                                                  )}
                                              </li>
                                              <li
                                                className="control-panel__share-map pointer"
                                                title={"Ver Legenda"}
                                                onClick={this.handleClickLayerLegend}
                                              >
                                                <SVGIcon id={"icon-legend"} />
                                              </li>
                                            </ul>
                                          </div>
                                          <div className="legend-panel">
                                            <div
                                              className="legend-panel__title"
                                              onClick={this.handleClickLayerLegend}
                                            >
                                              <span>Leyenda</span>
                                              <span
                                                className="legend-panel__category-caret"
                                                style={{ display: showLegend ? "block" : "none" }}
                                              >
                                                ▼
                                              </span>
                                              <span
                                                className="legend-panel__category-caret"
                                                style={{ display: showLegend ? "none" : "block" }}
                                              >
                                                ▲
                                              </span>
                                            </div>
                                            <div
                                              className="legend-panel__layers"
                                              style={{ display: showLegend ? "block" : "none" }}
                                            >
                                              <div>
                                                <MapLegend data={dataLegend} />
                                                <div id={instanceLegendMap}></div>
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      </CardBody>
                                    </Card>
                                  </Col>
                                </Row>
                        ) : 
                            (<p></p>)
                          }

      </div>
    );
  }
  /**
   * Handler: Cambio de temática
   */
  onTematicaChange(idTematica) {
    let me = this;
    me.setState({
      tematica: idTematica
    });
    // Actualizar path
    me.setUrlParam("tematica", idTematica);
    me.loadLayerMap(idTematica);
  }
  /**
   * Devuelve el codigo de región desde la URL actual
   *
   * @returns {string} Código de región
   */
  getCodigoRegionInicial() {
    return (
      this.urlParams.region || DEFAULT_REGION_CODE
    );
  }
  /**
   * Devuelve el codigo de región desde la URL actual
   *
   * @returns {string} Código de región
   */
  getCodigoTematicaInicial() {
    return this.urlParams.tematica || DEFAULT_TEMATICA_CODE;
  }

  getViewMap() {
    return this.urlParams.viewmap || DEFAULT_VIEW_MAP;
  }
  getViewMetadata() {
    return this.urlParams.viewmetadata || DEFAULT_METADATA;
  }
  /**
   * Handler: Cambio de región
   *
   * @param {object} idRegion
   */
  onRegionChange(idRegion) {
    let me = this,
      codigoRegion = idRegion ? idRegion : DEFAULT_REGION_CODE,
      nombreRegion = Ubigeo.getNombreRegionForUrl(codigoRegion);
    // Acualizar estado
    me.setState({ region: codigoRegion });
    me.processingData(codigoRegion);
    // Actualizar path
    me.setUrlParam("region", codigoRegion);
  }
  setUrlParam(key, value) {
    this.urlParams[key] = value;
    this.context.router.history.push(
      StringUtils.setUrlParams("./regiones", this.urlParams)
    );
  }
  onChangeColSize(e, size) {
    e.preventDefault();
    this.setState({ inlineCharts: size }, () => this.onChangeChartSize());
  }
  onChangeChartSize() {
    if (window.xchart && window.xchart.charts.length > 0) {
      window.xchart.charts.forEach(function (p) {
        if (p) {
          p.reflow();
        }
      });
    }
  }
}
export default VistaRegiones;
